import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import { PaymentResult } from './components/PaymentResult';
import Login from './components/Login';
import Security from './components/Security';

import './custom.css'

export default () => (
    <Layout>
        <Route exact path='/' component={Home} />
        <Route exact path='/thankyou' component={PaymentResult} />
    </Layout>
);
